/**
 * Nothing opens on its own here: either the app opens, or the visitor picks the
 * store. See lib/webViewAppOpen.
 */
export function RedirectAppOpenAttempted({ os }: { os: string }) {
  const store = os === "ios" ? "the App Store" : "Google Play";

  return (
    <p
      className={`
        mb-4 w-70 text-center text-sm text-slate-500
        system-dark:text-zinc-400
      `}
    >
      {`If the app didn't open, download it from ${store} below.`}
    </p>
  );
}
